import { render } from "./AdminForceupdateEdit.vue?vue&type=template&id=4b541981&scoped=true&ts=true&lang=true"
import script from "./AdminForceupdateEdit.vue?vue&type=script&lang=ts"
export * from "./AdminForceupdateEdit.vue?vue&type=script&lang=ts"

import "./AdminForceupdateEdit.vue?vue&type=style&index=0&id=4b541981&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b541981"]])

export default __exports__